import { JackPotTextParams } from "./JackPotTextParams";
import { JackpotDisplayDiamondPotStep } from "./JackpotDisplayDiamondPotStep";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { JackpotText } from "./JackpotText";
import { Scale, Size } from "./MyHelpers";
import { FontResource } from "./ResourceManager/FontResource";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { ScreenProtocolScope } from "./ScreenProtocol";
import { JackpotLevel } from "./api";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";
export class JackpotDisplayDiamondPotStepRappidFrames extends  JackpotDisplayDiamondPotStep {	
	public constructor(params: JackpotDisplayParams) {
		super(params);
		// this.resid = params.resid.Add("JackpotDisplayDiamondPotStepRappidFrames");
		// this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayDiamondPotStepRappidFrames");
		// this.view.classList.add(this.resid.ID());

		this.diamondPotStepJackpotContainer.style.right = Scale.Xpx(-130);
		this.diamondPotStepJackpotContainer.style.top = Scale.Xpx(0);

		this.rubyStepJackpotContainer.style.right = Scale.Xpx(-85);
		this.rubyStepJackpotContainer.style.top = Scale.Ypx(335);

		this.emmeraldStepJackotContainer.style.right = Scale.Xpx(-71);
		this.sapphireStepJackotContainer.style.right = Scale.Xpx(-58);		
	}

	public override async PrepareResources(loadingStage: LoadingStage,resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if(loadingStage != LoadingStage.System) return ;
		//load Sprite Jackpot 
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayDiamondPotStepRappidFrames/Sprites/jp4Frame", this.resid.Add("DiamondStepRapidFrames"), true, this.logGroup.Add("DiamondStepRapidFrames"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayDiamondPotStepRappidFrames/Sprites/jp3Frame", this.resid.Add("RubyStep"), true, this.logGroup.Add("RubyStep"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayDiamondPotStepRappidFrames/Sprites/jp2Frame", this.resid.Add("EmmeraldStep"), true, this.logGroup.Add("EmmeraldStep"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayDiamondPotStepRappidFrames/Sprites/jp1Frame", this.resid.Add("SapphireStep"), true, this.logGroup.Add("SapphireStep"), true));
		this.TitlePrepare(resourceManager);
		resourceManager.Add(new FontResource(this.jackpot + "fonts/newzone.ttf", this.resid.ScopedResourceName("JackpotFont")));
	}

	public override TitlePrepare(resourceManager: IWriteOnlyResourceManager) {
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayDiamondPotStepRappidFrames/Sprites/titleJackpotDisplay", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
	}

	public override TitleLoaded(resourceManager: IReadOnlyResourceManager) {
		this.titleSpriteAnim = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("title")).sprite, canvasSize: new Size(Scale.W(1000), Scale.H(600))});
		this.titleSpriteAnim.View().style.position = "absolute";
		this.titleSpriteAnim.View().style.bottom=Scale.Ypx(0);
		this.titleSpriteAnim.View().style.left= Scale.Xpx(18);
		//this.titleSpriteAnim.Scale(1.1);
		this.TitleContainer.appendChild(this.titleSpriteAnim.View());
	}
	
	protected override async createJPLevelText( resourceManager : ResourceManager){

		//this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		let jp4TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("White"),
			width: Scale.W(1326),
			height: Scale.H(170),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold : true,
			//colorStroke : "white",
		}

		this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(jp4TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.left = Scale.Xpx(241);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.top = Scale.Ypx(143); //84
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.diamondPotStepJackpotContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());

		let jp3TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Red"),
			width: Scale.W(800),
			height: Scale.H(146),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold : true,
			//colorStroke : "white",
		}

		//JackpotFont 3
		this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(jp3TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.left = Scale.Xpx(203);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.top = Scale.Ypx(121);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.position = "absolute";
		this.rubyStepJackpotContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp3].View());

		let jp2TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Green"),
			width: Scale.W(592),
			height: Scale.H(100),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold : true,
			//colorStroke : "white",
		}

		//JackpotFont 2
		this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(jp2TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.left = Scale.Xpx(188);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.top = Scale.Ypx(94);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.position = "absolute";
		this.emmeraldStepJackotContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp2].View());

		let jp1TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Blue"),
			width: Scale.W(493),
			height: Scale.H(95),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold : true,
			//colorStroke : "white",
		}

		//JackpotFont 1
		this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(jp1TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.left = Scale.Xpx(141);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.top = Scale.Ypx(65);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.position = "absolute";		
		this.sapphireStepJackotContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp1].View());

		this.jackpotTextMapping[JackpotLevel.Jp4].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp4].Start();

		this.jackpotTextMapping[JackpotLevel.Jp3].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp3].Start();

		this.jackpotTextMapping[JackpotLevel.Jp1].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp1].Start();

		this.jackpotTextMapping[JackpotLevel.Jp2].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp2].Start();
	}

	protected override createSpritesJpLevel(resourceManager : ResourceManager){
		//this.DragonJackpotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("diamond_frame")).CssBackground();


		this.diamondSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("DiamondStepRapidFrames")).sprite, canvasSize: new Size(Scale.W(1805), Scale.H(375))});
		//this.diamondSpriteJackpot.Start();
		this.diamondPotStepJackpotContainer.appendChild(this.diamondSpriteJackpot.View());
        //this.diamondSpriteJackpot.ScaleNonUniform(1.1,1);


		//this.GrandDragonJackpotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("ruby_frame")).CssBackground();
		this.rubySpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("RubyStep")).sprite, canvasSize: new Size(Scale.W(1200), Scale.H(320))});
		//this.rubySpriteJackpot.Start();
		this.rubySpriteJackpot.ScaleNonUniform(1.1, 1);
		this.rubyStepJackpotContainer.appendChild(this.rubySpriteJackpot.View());


		//this.MiniDragonJackotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("emerald_frame")).CssBackground();
		this.emmeraldSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("EmmeraldStep")).sprite, canvasSize: new Size(Scale.W(950), Scale.H(250))});
		//this.emmeraldSpriteJackpot.Start();
		//this.emmeraldSpriteJackpot.ScaleNonUniform(1.20, 1);
		this.emmeraldStepJackotContainer.appendChild(this.emmeraldSpriteJackpot.View());



		//this.MinorDragonJackotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("sapphire_frame")).CssBackground();
		this.sapphireSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("SapphireStep")).sprite, canvasSize: new Size(Scale.W(766), Scale.H(200))});
		//this.sapphireSpriteJackpot.Start();
		this.sapphireStepJackotContainer.appendChild(this.sapphireSpriteJackpot.View());

		this.allJpSpriteAnim.push(this.diamondSpriteJackpot);
		this.allJpSpriteAnim.push(this.rubySpriteJackpot);
		this.allJpSpriteAnim.push(this.emmeraldSpriteJackpot);
		this.allJpSpriteAnim.push(this.sapphireSpriteJackpot);

		// repeat at random intervals winthin 5 to 10 seconds
		this.diamondStartTimer = this.systemContext.TimingContext().CreateRandomInterval("diamondStartTimer", 10000, 30000, () => this.diamondSpriteJackpot.Start(false));
		this.rubyStartTimer = this.systemContext.TimingContext().CreateRandomInterval("rubyStartTimer", 10000, 30000, () => this.rubySpriteJackpot.Start(false));
		this.shappireStartTimer = this.systemContext.TimingContext().CreateRandomInterval("shappireStartTimer", 10000, 30000, () => this.sapphireSpriteJackpot.Start(false));
		this.emeraldStartTimer = this.systemContext.TimingContext().CreateRandomInterval("emeraldStartTimer", 10000, 30000, () => this.emmeraldSpriteJackpot.Start(false));
		this.titleStartTimer = this.systemContext.TimingContext().CreateRandomInterval("titleStartTimer", 10000, 30000, () => this.titleSpriteAnim.Start(false));

		this.allJpTimers.push(this.diamondStartTimer);
		this.allJpTimers.push(this.rubyStartTimer);
		this.allJpTimers.push(this.shappireStartTimer);
		this.allJpTimers.push(this.emeraldStartTimer);
	}
}